import React from 'react'

const Map = () => (
    <div className="map" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <iframe title="Beautiful map" style={{width:'100%'}} height="400" frameBorder="0" src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJ_fRm01ThE0cRWWdF-uHnI80&amp;key=AIzaSyAwD2S3tGm8kS6s6AoQuQdixVjq0BZE7Ps"></iframe>
        <i className="subtitle" style={{paddingTop: '2em'}}>Ideální spoj pro účastníky z daleka: nádraží Ostrava-Svinov → autobus 37 → zastávka Nábřeží.</i>
    </div>
)

export default Map